import IsServerSideRendering from '../utilities/IsServerSideRendering';

function getCookie(name) {
  if (IsServerSideRendering) return {};

  const regexp = new RegExp(`(?:^${name}|; *${name})=(.*?)(?:;|$)`, 'g');
  const result = regexp.exec(document.cookie);
  return (result === null) ? null : result[1];
}

function getAllCookies() {
  if (IsServerSideRendering) return {};
  
  const cookies = document.cookie.split('; ').reduce((cookies, current) => {
    const [name, ...value] = current.split('=');
    cookies[name] = value.join('=');
    return cookies;
  }, {});
  return cookies;
}

function setCookie(name, value, expireDate) {
  if (IsServerSideRendering) return;

  const expires = expireDate ? `; expires=${expireDate}` : '';
  document.cookie = `${name}=${value}${expires}; path=/`;
}

function deleteCookie(name) {
  this.setCookie(name, '', -1);
}

export default {
  getCookie, getAllCookies, setCookie, deleteCookie,
};
